var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenya({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.24245 0 3.1317 2.76867 1.1907 6.78263H22.8092C20.8683 2.76867 16.7575 0 12 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C7.24245 24 3.1317 21.2313 1.1907 17.2174H22.8092C20.8683 21.2313 16.7575 24 12 24Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4333 8.34784H0.566672C0.199078 9.49951 0 10.7265 0 12C0 13.2736 0.199078 14.5005 0.566672 15.6522H23.4333C23.8009 14.5005 24 13.2736 24 12C24 10.7265 23.8009 9.49951 23.4333 8.34784Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7366 5.54536L14.3155 4.88943L12 10.1325L9.68448 4.88943L8.26337 5.54536L11.1381 12L8.26337 18.4546L9.68448 19.1106L12 13.8675L14.3155 19.1106L15.7366 18.4546L12.8619 12L15.7366 5.54536Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9652 6.16355C12.4151 5.56275 12 5.21738 12 5.21738C12 5.21738 11.5849 5.5627 11.0348 6.16355V17.8364C11.5849 18.4373 12 18.7826 12 18.7826C12 18.7826 12.4151 18.4373 12.9652 17.8364V6.16355Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39133 8.40202V15.5979C9.97267 16.628 10.6842 17.4723 11.2174 18.0321V5.9679C10.6842 6.52763 9.97262 7.37199 9.39133 8.40202Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 8.40202C14.0273 7.37194 13.3158 6.52763 12.7826 5.9679V18.0321C13.3158 17.4723 14.0273 16.628 14.6087 15.5979V8.40202Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 8.40201V15.5979C15.1972 14.555 15.6522 13.3217 15.6522 12C15.6522 10.6783 15.1972 9.44498 14.6087 8.40201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39132 8.40201V15.5979C8.80281 14.555 8.34784 13.3217 8.34784 12C8.34784 10.6783 8.80281 9.44498 9.39132 8.40201Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.566a211641b1744692636607165baaf7.svg";
export { ForwardRef as ReactComponent };